<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="522px" :before-close="closeModal">
    <AlertCompany :primaryColor="getPrimaryColorHex.four" :secundaryColor="getPrimaryColorHex.one" class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-2">
        Nova empresa
    </h3>
    <p class="c-ndarkfour regular text-center">
        De que forma deseja adicionar essa empresa?
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
<!--         <Button type="outline" :color="getPrimaryColor">
            Importar cadastro
        </Button> -->
        <el-upload
            class="upload-demo"
            action="not"
            :auto-upload="false"
            :limit="3"
            :show-file-list="false"
            :on-change="handleFileChange"
            accept=".xls,.xlsx">
            <!-- <el-button size="small" type="primary">Click to upload</el-button> -->
            <Button type="outline" :color="getPrimaryColor">
                Importar cadastro
            </Button>
        </el-upload>
        <Button class="ml-4" @click="gotoNewCompany" :color="getPrimaryColor">
            Cadastrar empresa
        </Button>
    </span>
</el-dialog>
</template>

<script>
import AlertCompany from '@/components/icons/AlertCompany'
import importCompanies from '@/api/importCompanies'
import getCompanies from '@/api/getCompanies'
export default {
    components: {
        AlertCompany
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        companyType: {
            required: true,
            type: String,
        }
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        gotoNewCompany() {
            this.$router.push(`/company/new/${this.companyType}`)
        },
        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),
        async handleFileChange(file) {
            const base64File = await this.toBase64(file.raw)
            const base64Header = base64File.indexOf(',') + 1
            const fileData = {
                companyType: this.companyType,
                cnpjFile: base64File.slice(base64Header , base64File.length)
            }
            const result = await importCompanies(fileData)
            if (result.data.ok) {
                const companyImportTotal = result.data.payload.filter(company => company != null).length
                this.$notify({
                    title: companyImportTotal == 1 ? 'Foi cadastrada 1 empresa' : `Foram cadastradas ${companyImportTotal} empresas.`,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                })
            } else {
                this.$notify({
                    title: `Parece que há algo de errado com o arquivo`,
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                })
            }
            await getCompanies({ page: 1 })
            this.$emit('closeModal', false)
        },
    },
}
</script>

<style>
</style>